@if (loading()) {
  <p-progressbar mode="indeterminate" styleClass="ui-core-data-table-loader mt-3" />
}
@if (globalFilterTpl()) {
  <ng-container *ngTemplateOutlet="globalFilterTpl()!; context: { $implicit: dt }" />
}
<p-table
  #dt
  styleClass="rr-table d-block {{ loading() ? '' : 'mt-2' }} {{ styleClass() }}"
  [dataKey]="dataKey()"
  [value]="data().items"
  [lazy]="lazy()"
  [loading]="loading()"
  [loadingIcon]="'pi'"
  [paginator]="paginator()"
  [showCurrentPageReport]="showCurrentPageReport()"
  [globalFilterFields]="globalFilterFields()"
  [rows]="data().size"
  [size]="size()"
  [totalRecords]="data().total"
  [currentPageReportTemplate]="'Showing {first} - {last} of {totalRecords} entries'"
  [rowsPerPageOptions]="[5, 10, 100]"
  [columns]="columns()"
  [tableStyle]="{ 'min-width': '50rem' }"
  [selection]="selectedItems()"
  [selectionMode]="selectionMode()"
  [selectionPageOnly]="true"
  [paginatorDropdownAppendTo]="'body'"
  [resizableColumns]="true"
  [columnResizeMode]="'expand'"
  (onLazyLoad)="getTableData.emit($event)"
  (selectionChange)="selectItems.emit($event)"
>
  <ng-template #header let-columns>
    <tr>
      @if (selectable()) {
        <th class="ps-1 w-0" scope="colgroup">
          @if (canSelectAll()) {
            <p-tableHeaderCheckbox />
          }
        </th>
      }
      @for (col of columns; track col) {
        <th
          scope="col"
          [pSortableColumn]="col.sortable ? col.field : null"
          [ngClass]="{ 'w-6rem': col.field === 'actions' }"
          [style.width]="col?.width"
        >
          {{ col.header }}
          @if (col.sortable) {
            <p-sortIcon [field]="col.field" />
          }
          @if (col.filterable) {
            @if (col.filterTpl) {
              <p-columnFilter
                #colFilter
                display="menu"
                matchMode="equals"
                [field]="col.field"
                [showMatchModes]="false"
                [showOperator]="false"
                [showAddButton]="false"
                [showApplyButton]="false"
                [showClearButton]="false"
                (onShow)="onShowFilter()"
              >
                <ng-template #filter let-value let-filterCallback="filterCallback">
                  <div class="rr-table-filter-wrapper">
                    <ng-container
                      *ngTemplateOutlet="col.filterTpl; context: { $implicit: value, assignFilter, filterActionsTpl }"
                    ></ng-container>
                  </div>
                  <ng-template #filterActionsTpl>
                    <div class="d-flex mb-4 justify-content-between px-3">
                      <p-button
                        label="Clear"
                        size="small"
                        [outlined]="true"
                        (onClick)="onClearFilter(filterCallback, colFilter)"
                      ></p-button>
                      <p-button
                        label="Apply"
                        size="small"
                        (onClick)="onApplyFilter(filterCallback, colFilter)"
                      ></p-button>
                    </div>
                  </ng-template>
                </ng-template>
              </p-columnFilter>
            } @else {
              <p-columnFilter
                #colFilter
                display="menu"
                matchMode="contains"
                type="text"
                [field]="col.field"
                [showMatchModes]="false"
                [showOperator]="false"
                [showAddButton]="false"
                [showApplyButton]="true"
              >
              </p-columnFilter>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
    <tr>
      @if (selectable()) {
        @if (selectionMode() === "multiple") {
          <td class="table-checkbox-row">
            <p-tableCheckbox [value]="rowData" />
          </td>
        } @else {
          <td class="table-radio-row">
            <p-tableRadioButton [value]="rowData" />
          </td>
        }
      }
      @for (col of columns; track col) {
        <td
          [style.width]="col?.width"
          [ngClass]="{
            'p-0': col.field === 'actions',
            'disabled-cell': col.disabled && col.disabled(rowData),
          }"
        >
          @if ((rowData[col.field] !== null && rowData[col.field] !== undefined) || col.field === "actions") {
            @switch (col.type) {
              @case ("date") {
                {{ rowData[col.field] | date: "dd/MM/yyyy" }}
              }
              @case ("enum") {
                @if (col.data) {
                  {{ rowData[col.field] | rrUiCoreEnumDescription: col.data.enum }}
                } @else {
                  -
                }
              }
              @case ("link") {
                @if (col.data && (!col.display || (col.display && col.display(rowData)))) {
                  <a
                    href
                    rrUiCoreLinkStopPropagation
                    (click)="col.disabled && col.disabled(rowData) ? null : col.data.click(rowData)"
                    >{{ col.data.title(rowData[col.field]) }}</a
                  >
                } @else {
                  -
                }
              }
              @case ("template") {
                <ng-container *ngTemplateOutlet="col.data; context: { $implicit: rowData }"></ng-container>
              }
              @case ("computed") {
                {{ col.data(rowData) }}
              }
              @default {
                @if (rowData[col.field]) {
                  <span [innerHTML]="rowData[col.field] | rrUiCoreSanitizeHtml"></span>
                } @else {
                  -
                }
              }
            }
          } @else {
            -
          }
        </td>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td [attr.colspan]="selectable() ? columns().length + 1 : columns().length" class="text-center">
        {{ noDataMessage() }}
      </td>
    </tr>
  </ng-template>
</p-table>
